import AbstractController from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController';
import Controller from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller';
import HeaderSlider from '../Elements/HeaderSlider';

/**
 * Header Slider Controller
 *
 * @class
 */
class HeaderSliderController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(HeaderSlider);
  }
}

export default (new HeaderSliderController);
